import { withForm } from '@new/common/hooks/form/form';

import { cn } from '@new/lib';
import { SITUATION_OPTIONS } from '../../../utils/setupOptions';
import { wizardDefaultValues } from '../../../schemas/wizard.schema';

export const AcademicSituationStep = withForm({
  defaultValues: wizardDefaultValues,
  render: ({ form }) => (
    <div className="flex flex-col gap-6">
      <div>
        <h2 className="m-0! [font-size:var(--fs-h5)]! font-bold text-(--neutral-black-NB1000)!">
          Academic Situation
        </h2>
        <p className="mt-1 [font-size:var(--fs-p3)]! text-(--neutral-black-NB700)!">
          Which best describes your current academic situation?
        </p>
      </div>

      <form.AppField name="priorEducationStatus">
        {(field) => (
          <div role="radiogroup" className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {SITUATION_OPTIONS.map((option) => {
              const selected = field.state.value === option.value;
              return (
                <button
                  key={option.value}
                  type="button"
                  role="radio"
                  aria-checked={selected}
                  onClick={() => field.handleChange(option.value)}
                  className={cn(
                    'flex h-full cursor-pointer flex-col gap-2 overflow-hidden rounded-[9px]! border border-solid p-5 text-left transition-all duration-150',
                    selected
                      ? 'border-(--primary-O900) bg-(--primary-O200)'
                      : 'border-(--neutral-black-NB200) bg-(--neutral-white-NW1000) hover:-translate-y-0.5 hover:border-(--primary-O900) hover:bg-(--primary-O200)/40 hover:shadow-md'
                  )}
                >
                  <span
                    className={cn(
                      '[font-size:var(--fs-p2)]! font-semibold',
                      selected ? 'text-(--primary-O900)!' : 'text-(--neutral-black-NB1000)!'
                    )}
                  >
                    {option.title}
                  </span>
                  <span className="[font-size:var(--fs-p4)]! font-medium text-(--neutral-black-NB800)!">
                    {option.subtitle}
                  </span>
                  <span className="[font-size:var(--fs-l4)]! text-(--neutral-black-NB700)!">
                    {option.description}
                  </span>
                </button>
              );
            })}
          </div>
        )}
      </form.AppField>
    </div>
  ),
});
